export default __webpack_public_path__ + "static/media/navBars.e8db7520.svg";